import { HIDE_BUTTON_POWER } from '../../const';

const COMMAND_TYPES = ['B1.0', 'B1.1', 'B1.3', 'B1.4', 'B1.5', 'B1.6', 'B1.8', 'B1.9'];
export const supportsCommands = mc => COMMAND_TYPES.includes(mc.softwareType) && !HIDE_BUTTON_POWER.includes(mc.softwareType);

export const TYPE_FIELDS = {
  'B1.0': ['sensor1', 'sensor2', 'delta', 'effective'],
  'B1.1': ['sensor1', 'mode', 'setPoint'],
  'B1.3': [],
  'B1.4': ['sensor1', 'min', 'max'],
  'B1.5': ['sensor1', 'humidity', 'mode', 'setPoint'],
  'B1.6': ['sensor1', 'sensor2', 'delta', 'effective', 'mode'],
  'B1.7': [],
  'B1.8': ['sensor1', 'humidity', 'mode', 'setPoint'],
  'B1.9': ['sensor1', 'sensor2', 'delta', 'min', 'max'],
  'B2.0': ['sensor1', 'min', 'max'],
  'B2.1': [],
  'B2.2': ['sensor1', 'min', 'max', 'parentName'],
};

export function tableRow(mc, bt) {
  const sensor = number => mc.sensors?.find(item => String(item.number) === number)?.value;
  const numeric = value => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value)) ? Number(value) : null;
  const live = value => mc.isConnected ? numeric(value) : null;
  const sensorFault = mc.isB22Sensor && ((mc.faults || [mc.fault]).includes('SENSOR_DISCONNECTED') || !Number.isFinite(mc.temperature));
  return { ...mc, device: mc.deviceType ? bt(mc.deviceType) : '', areaName: mc.area?.name || '',
    connection: bt(!mc.isConnected ? 'MC_DISCONNECTED' : sensorFault ? 'SENSOR_DISCONNECTED' : 'CONNECTED_STATUS'),
    power: supportsCommands(mc) ? bt(mc.isConnected && mc.turnOnDate ? 'ON_MC' : 'OFF_MC') : '',
    faultText: (mc.faults || [mc.fault]).filter(Boolean).map(bt).join(', '),
    sensor1: sensorFault ? null : live(mc.isB22Sensor ? mc.temperature : sensor('1')),
    sensor2: live(sensor('2')), humidity: live(sensor('2')),
    delta: live(mc.delta), effective: live(mc.effective),
    min: numeric(mc.rangeSettings?.minTemp), max: numeric(mc.rangeSettings?.maxTemp),
    mode: mc.isConnected && (mc.ac?.modeActive || mc.acThermostat?.modeActive) ? bt(mc.ac?.modeActive || mc.acThermostat?.modeActive) : '',
    setPoint: live(mc.ac?.setPointActive),
  };
}
